import { useEffect, useMemo } from 'react';
import { LIST_RECIPIENTS_MAX_PAGE_SIZE, requestFactory, useListRecipients } from '@frontend/api-bulk-messaging';
import { useAppScopeStore } from '@frontend/scope';
import { dedupeRecipients } from '../utils/dedupe-recipients';

type Props = {
  campaignId: string;
  enabled: boolean;
};

export const useInitialRecipients = ({ campaignId, enabled }: Props) => {
  const { selectedOrgId: orgId } = useAppScopeStore();

  const request = requestFactory.listRecipients({
    campaignId,
    orgId,
    pageSize: LIST_RECIPIENTS_MAX_PAGE_SIZE,
  });

  const { data, hasNextPage, fetchNextPage, isFetching, isLoading } = useListRecipients(request, {
    enabled,
  });

  useEffect(() => {
    if (enabled && hasNextPage && !isFetching) {
      fetchNextPage();
    }
  }, [enabled, hasNextPage, isFetching, fetchNextPage]);

  const initialRecipients = useMemo(() => {
    if (!data?.pages) return [];
    const mergedRecipients = data.pages.flatMap((page) => page.rows || []);
    return dedupeRecipients(mergedRecipients);
  }, [data]);

  return {
    initialRecipients,
    isLoading: isLoading || isFetching,
  };
};
